<template>
	<div
		v-if="criterias.length > 0"
		class="col-12 px-0 pe-3 mb-2 mb-md-5 text-start"
	>
		<div class="body-strong mb-4 text-grey-900">
			{{ content.planner_prestationsPrivateKitchen }}
		</div>
		<div class="d-flex flex-row flex-wrap pe-4 px-lg-0">
			<div
				v-for="i in criteriasQuantity"
				:key="i"
				class="col-6 px-0 mt-1 mb-2 mb-md-1 d-flex flex-row nowrap justify-content-start align-items-center"
			>
				<!-- <div class="me-1">
					<svg
						:color="svgColor"
						:width="svgSize"
						:height="svgSize"
						class="icon"
					>
						<use :xlink:href="`#___icon___${criterias[i - 1].svgName}`"></use>
					</svg>
				</div> -->
				<div class="me-3 d-flex">
					<svg class="icon text-primary-blue" :width="14" :height="10">
						<use xlink:href="#___icon___check"></use>
					</svg>
				</div>
				<span class="body text-grey-900">{{ criterias[i - 1].label }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "PrivateKitchen",
	props: {
		prestation: {
			type: Object,
			default: () => {
				return {};
			},
		},
		quantity: {
			type: Number,
			default: 12,
		},
		svgSize: {
			type: Number,
			default: 11,
		},
		svgColor: {
			type: String,
			default: "#52B3D8",
		},
	},
	computed: {
		...mapState(["content"]),
		...mapGetters(["inPrivateKitchen_criterias"]),
		criterias() {
			return (
				this.inPrivateKitchen_criterias[this.prestation.prestationId] || []
			);
		},
		criteriasQuantity() {
			return this.criterias.length > this.quantity
				? this.quantity
				: this.criterias.length;
		},
	},
};
</script>

<style scoped></style>
